import React, { FC } from 'react'
import s from './HeroSection.module.scss'
import { BACKEND_URL } from '../../../api'

interface HeroSectionProps {
    mainImage?: string
    title: string
}

const HeroSection: FC<HeroSectionProps> = ({ mainImage, title }) => {
    if (!mainImage) return null

    return (
        <section className={s.hero}>
            <div className={`${s.heroContainer} container`}>
                <h2 className={`${s.title} title`}>ПРОГРАММНОЕ ОБЕСПЕЧЕНИЕ "PNX_DF" для АСУ ТП </h2>
                <div className={s.heroImage}>
                    <img src={BACKEND_URL + mainImage} alt={title} />
                </div>
            </div>
        </section>
    )
}

export default HeroSection

